import { HttpClient } from '@angular/common/http';
import BigNumber from 'bignumber.js';
import { tap } from 'rxjs/operators';
import { Base } from '../base';
import { PoolSnapshots } from './pools/pool-snapshots';
import { Funds } from './pools/funds';
import { WithdrawSignatures } from './pools/withdraw-signatures';

export class Pools extends Base {
  constructor(protected httpClient: HttpClient, private parent: string) {
    super(httpClient, `${parent}/pools`);
  }

  of(id: string) {
    id = id.toLowerCase();
    return {
      poolSnapshots: new PoolSnapshots(this.httpClient, this.pathJoin(id)),
      funds: new Funds(this.httpClient, this.pathJoin(id)),
      withdrawSignatures: new WithdrawSignatures(this.httpClient, this.pathJoin(id))
    };
  }

  query(params?: any) {
    return this.api.query(params).pipe(
      tap((json) => json.pools.forEach((p: any) => this.processRecord(p)))
    );
  }

  get(id: any) {
    return this.api.get(id).pipe(
      tap((json) => this.processRecord(json.pool))
    );
  }

  private processRecord(record: any) {
    record.reservedRate = new BigNumber(record.reservedRate).fromDecimal();
    record.totalShares = new BigNumber(record.totalShares).fromDecimal();
    record.withdrawFeeRate = new BigNumber(record.withdrawFeeRate).fromDecimal();
  }
}
